import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ContactFormWrapper from '../components/ContactFormWrapper';
import { motion } from "framer-motion";

const WebbDesignPage = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Box sx={{ px: 3, py: 5, maxWidth: '900px', mx: 'auto' }}>
        <Typography variant="h4" gutterBottom sx={{ color: '#c6a04c' }}>
          💻 {t("webbdesign.title")}
        </Typography>

        <Typography variant="body1" paragraph>
          {t("webbdesign.text")}
        </Typography>

        <ContactFormWrapper
          type="full"
          pageName="WebbDesign"
          hideFields={['startDate', 'services', 'employees', 'previousSystem', 'businessStatus', 'requestedServices']}
          redirectPath="/"
          showHeader={false}
        />
      </Box>
    </motion.div>
  );
};

export default WebbDesignPage;
